import styled from "styled-components";
import { DatePicker } from "@mui/x-date-pickers";

export const FieldRow = styled.div`
  display: flex;
  align-items: end;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
`;

export const FieldColumn = styled.div`
  flex: 1;
  min-width: 200px;
`;

export const FormContainer = styled.div``;

export const ButtonsBlock = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 20px;
`;

export const Section = styled.div`
  margin-bottom: 20px;
`;

export const SectionTitle = styled.h2`
  font-size: 20px;
  margin-bottom: 10px;
  margin-top: 0;
`;

export const StyledDatePicker = styled(DatePicker)(() => ({
  width: "100%",
  padding: "5px",
  "& .MuiInputBase-root": {
    height: 41,
    boxSizing: "border-box",
    padding: "0 10px",
    fontSize: "16px",
  },
  "& .MuiInputBase-input": {
    padding: 0,
    height: "41px",
    lineHeight: "41px",
  },
  "& .MuiInputLabel-root": {
    transform: "translate(14px, 10px) scale(1)",
    "&.Mui-focused, &.MuiFormLabel-filled": {
      transform: "translate(14px, -9px) scale(0.75)",
    },
  },
  "[dir='rtl'] & .MuiInputLabel-root": {
    transform: "translate(-14px, 10px) scale(1)",
  },
  "[dir='rtl'] & .MuiInputLabel-root.Mui-focused, [dir='rtl'] & .MuiInputLabel-root.MuiFormLabel-filled":
    {
      transform: "translate(-14px, -9px) scale(0.75)",
    },
  "& .MuiOutlinedInput-root": {
    "& input": {
      height: "100%",
      padding: "10px 14px",
    },
  },
}));
